import axios, { type AxiosError, type InternalAxiosRequestConfig } from "axios";

import { getMidwayCookie } from "src/cookies";
import { retrieveMidwayToken } from "src/midway/MidwayConnector";

const AUTHORIZATION_HEADER_KEY = "Authorization";

export const awsJWTAuthAxiosInterceptor = (
  requestConfig: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  requestConfig.headers.set(
    AUTHORIZATION_HEADER_KEY,
    getMidwayCookie() || "unauthenticated"
  );
  return requestConfig;
};

export const awsJWTAuthErrorAxiosInterceptor = (
  error: AxiosError
): Promise<InternalAxiosRequestConfig | AxiosError> => {
  if (error?.response?.status === 401 && error.config) {
    retrieveMidwayToken();
    error.config.headers.set(
      AUTHORIZATION_HEADER_KEY,
      getMidwayCookie() || "unauthenticated"
    );
    return axios.request(error.config);
  }

  return Promise.reject(error);
};
